module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"ja":{"h-1":"活用事例","lead":"WareXをご利用になった:お客様の活用事例をご紹介いたします。:","button":"活用事例一覧へ"}}')
  delete Component.options._Ctor
}
